import React from "react";
import { Flex, Switch, Text } from "@chakra-ui/react";
import { Sport } from "../data/api";

type Props = {
  sport: Sport;
  onToggle: () => any;
  checked: boolean;
};

const SportNotificationSwitch = ({ sport, onToggle, checked }: Props) => {
  return (
    <Flex justifyContent="space-between" alignItems="center" w="full">
      <Text fontSize="lg">{sport.title}</Text>
      <Switch size="lg" onChange={onToggle} isChecked={checked} />
    </Flex>
  );
};

export default SportNotificationSwitch;
